/* eslint-disable react/button-has-type */
import React from "react";

type Status = "Pendente" | "Dispensado" | "Aprovado" | "Analise";

interface StatusInfo {
    colorFont: string;
    colorBorder: string;
    colorBg: string;
    label: string;
    description: string;
}

interface BotaoStatusProps {
    status: Status;
}

const statusConfig: Record<Status, StatusInfo> = {
    Pendente: {
        colorFont: "#660410",
        colorBorder: "#FF5B6B",
        colorBg: "#FFBBBB",
        label: "Pendente",
        description: "Seu TACH possui pendência, necessário sua ação.",
    },
    Dispensado: {
        colorFont: "#1E1E1E",
        colorBorder: "#1E1E1E",
        colorBg: "#FFF",
        label: "Dispensado",
        description:
            "Não há carga horária não letiva, sendo dispensado de criar seu TACH.",
    },
    Aprovado: {
        colorFont: "#1A5903",
        colorBorder: "#7EE543",
        colorBg: "#EAFFD9",
        label: "Aprovado",
        description: "Seu TACH não possui pendências.",
    },
    Analise: {
        colorFont: "#D48806",
        colorBorder: "#FAAD14",
        colorBg: "#FFFDD9",
        label: "Aguardando aprovação",
        description:
            "Seu TACH está em análise. Você pode verificar o status com sua coordenação.",
    },
};

const BotaoStatus: React.FC<BotaoStatusProps> = ({ status }) => {
    const config = statusConfig[status];

    return (
        <div className="botaoStatus">
            <button
                style={{
                    backgroundColor: config.colorBg,
                    color: config.colorFont,
                    minHeight: "40px",
                    height: "100%",
                    border: "1px solid",
                    borderRadius: "64px",
                    borderColor: config.colorBorder,
                    padding: "8px 16px",
                    fontWeight: "bold",
                    cursor: "default",
                    gap: "10px",
                    textAlign: "center",
                }}
            >
                {config.label}
            </button>
            <p
                style={{
                    marginTop: "8px",
                    fontFamily: "Source Sans Pro",
                    fontWeight: 400,
                    fontStyle: "normal",
                    fontSize: "13px",
                    lineHeight: "124%",
                    letterSpacing: "0px",
                    verticalAlign: "middle",
                    color: "#383838",
                }}
            >
                {config.description}
            </p>
        </div>
    );
};

export default BotaoStatus;
